<template>
	<vs-prompt
		:active.sync="activeProp"
		:buttons-hidden="true"
		:title="$t('confirmPayment')"
		:cancel-text="$t('refuse')"
		button-accept="false"
		button-cancel="filled"
		color="warning"
		class="confirm-popup"
	>
		<div class="con-example-prompt">
			<div class="vx-col">
				<vs-input
					v-model="amountData"
					:label="$t('priceForClient')"
					class="w-full"
				/>
			</div>

			<div class="flex justify-end mt-3">
				<vs-button @click="confirm" color="warning">
					{{ $t("confirm") }}
				</vs-button>
			</div>
		</div>
	</vs-prompt>
</template>

<script>
export default {
	name: "ConfirmManuallyPayment",
	props: {
		active: { default: false, type: Boolean },
		amount: { default: "", type: [String, Number] }
	},

	data() {
		return {
			amountData: ""
		};
	},

  watch: {
    amount(newVal) {
      if (newVal) {
        this.amountData = newVal
      }
    }
  },

	computed: {
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		}
	},

	methods: {
		confirm() {
			this.$emit("confirm", this.amountData);
			this.activeProp = false;
		},

		close() {
			this.activeProp = false;
			this.setDefaultPrice();
		},

		setDefaultPrice() {
			this.amountData = this.amount;
		}
	},
};
</script>

<style lang="scss">
.confirm-popup {
	.vs-dialog {
		max-width: 270px;
	}
}
</style>
